module.exports = __webpack_public_path__ + "img/1436564270.e6db4f89.jpg";